import { Component } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { Contact, CIVILITES_CONTACT, ContactTelephone } from '../../../core/models/contact.model';
import { ContactService } from '../../../core/services/contact.service';
import { APP_ROUTES } from '../../../core/constants/app-routes';
import { TranslateModule } from '@ngx-translate/core';
import { I18nValuePipe } from '../../../core/pipes/i18n-value.pipe';
import { HelpTipComponent } from '../../../shared/help-tip/help-tip.component';

@Component({
    selector: 'app-ajout-contact',
    templateUrl: './ajout-contact.component.html',
    styleUrls: ['./ajout-contact.component.css'],
    imports: [FormsModule, ReactiveFormsModule, RouterLink, TranslateModule, I18nValuePipe, HelpTipComponent]
})
export class AjoutContactComponent {
  saving = false;
  error = false;
  readonly civilites = CIVILITES_CONTACT;
  readonly routes = APP_ROUTES;

  readonly form = this.fb.nonNullable.group({
    civilite: [''],
    nom: ['', Validators.required],
    prenom: ['', Validators.required],
    telephone: [''],
    mail: [''],
    notes: [''],
  });

  constructor(
    private readonly fb: FormBuilder,
    private readonly contactService: ContactService,
    private readonly router: Router
  ) {}

  submit(): void {
    if (this.form.invalid || this.saving) {
      this.form.markAllAsTouched();
      return;
    }

    const value = this.form.getRawValue();
    const contact = new Contact();
    contact.civiliteDto = value.civilite.trim() || undefined;
    contact.nomDto = value.nom.trim();
    contact.prenomDto = value.prenom.trim();
    contact.mailDto = value.mail.trim() || undefined;
    contact.notesDto = value.notes.trim() || undefined;

    const numero = value.telephone.trim();
    if (numero) {
      const telephone = new ContactTelephone();
      telephone.numeroDto = numero;
      telephone.parDefautDto = true;
      telephone.actifDto = true;
      contact.telephonesDto = [telephone];
    }

    this.saving = true;
    this.error = false;

    this.contactService.create(contact).subscribe({
      next: (created) => {
        const id = created?.idContactDto;
        if (id) {
          this.router.navigate([APP_ROUTES.contacts, id]);
          return;
        }
        this.router.navigate([APP_ROUTES.contacts]);
      },
      error: () => {
        this.saving = false;
        this.error = true;
      },
    });
  }
}
